(function () {
  if (window.__gosourcelyGa4EventsInitialized) return;
  window.__gosourcelyGa4EventsInitialized = true;

  function gtagEvent(eventName, params) {
    if (typeof window.gtag !== "function") return;
    window.gtag("event", eventName, params);
  }

  document.addEventListener("cart:update", function (event) {
    const data = event.detail?.data;

    if (!data?.isIncremental || data.didError) return;

    gtagEvent("add_to_quote", {
      product_id: data.productId || undefined,
      variant_id: data.variantId || undefined,
      quantity: data.itemCount || undefined,
      source: data.source || "storefront",
    });
  });

  window.__gosourcelyGa4TrackQuoteSubmitted = function (params) {
    const eventParams = Object.assign({ transport_type: "beacon" }, params);

    gtagEvent("quote_submitted", eventParams);
    gtagEvent("generate_lead", {
      transport_type: "beacon",
      currency: "EUR",
      value: 0,
      lead_source: params?.source || "general",
      item_count: params?.item_count,
      attachment_count: params?.attachment_count,
    });
  };
})();
